<template>
  <input
    class="il-input"
    type="date"
    :value="modelValue"
    @input="$emit('update:modelValue', $event.target.value)"
  />
</template>

<script>
/*
  A date field that is nothing but the browser's own control.

  Every device already knows how to work this one: a tap opens the system
  picker on an iPhone and on Android, and on a desktop the day, month and
  year boxes take typed digits as well. Its value is the same 'yyyy-mm-dd'
  string this module stored before, so Firestore and every formatter are
  unchanged.

  The order the boxes are drawn in belongs to the browser and cannot be set
  from CSS - dd/mm/yyyy on an Israeli locale, mm/dd/yyyy on US English - so
  the .date-hint beside each field spells the value out in Israeli format.
*/
export default {
  name: 'IlDateInput',
  props: { modelValue: { type: String, default: '' } },
  emits: ['update:modelValue'],
}
</script>

<style scoped>
.il-input {
  width: 100%;
  min-width: 165px;
  height: 35px;
  padding: 0 0.6rem;
  border: 0.5px solid lightgrey;
  border-radius: 3px;
  background: #fff;
  font: inherit;
  /* 16px also keeps iOS from zooming the page when the control takes focus */
  font-size: 16px;
  /* The forms turn their container white-on-dark below 600px, and an inherited
     colour would paint this value white on its own white background - unreadable
     on a phone. Both properties are needed: WebKit paints form-control text
     through -webkit-text-fill-color, which wins over colour when inherited. */
  color: #000;
  -webkit-text-fill-color: #000;
  /* App.vue sets direction: rtl on every element; a date is read left to
     right. Blink ignores this on its own date control - it orders the boxes
     by the browser's locale either way - but engines that do honour it draw
     day, month and year the way they are read */
  direction: ltr;
  text-align: left;
  outline: none;
}
.il-input:hover,
.il-input:focus {
  border: 1.1px solid lightblue;
}

/* Safari and iOS draw the value through this one */
.il-input::-webkit-date-and-time-value {
  color: #000;
  -webkit-text-fill-color: #000;
}
/* Chrome and Android draw the editable segments through these */
.il-input::-webkit-datetime-edit {
  color: #000;
  -webkit-text-fill-color: #000;
}
.il-input::-webkit-datetime-edit-text {
  color: #000;
  -webkit-text-fill-color: #000;
}
.il-input::-webkit-datetime-edit-day-field,
.il-input::-webkit-datetime-edit-month-field,
.il-input::-webkit-datetime-edit-year-field {
  color: #000;
  -webkit-text-fill-color: #000;
}
</style>
